import { greenStopColors, redStopColors } from "@common-components/top-menu/extension-top-button-bar";
import MenuIconButton from "@common-components/top-menu/menu-icon-button";
import { Sync, SyncDisabled } from "@mui/icons-material";
import { selectIsCurrentUserSessionConnected } from "@common-reducers/UserSelectors";
import { useAppSelector } from "@common-reducers/hooks/store.hook";
import { useNowTick } from "@common/hooks/use-now-tick";
import PropTypes from 'prop-types';
import React from 'react';

const SocketConnectionStatusButton = ({ onClick }: { onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void }) => {
  // Throttled tick so the lastSeen-freshness derivation re-evaluates over time (flip to disconnected
  // after a real >6-min silence, not on every transient MQTT blip).
  const now = useNowTick();
  const isSocketConnectedToWhatsApp = useAppSelector(state => selectIsCurrentUserSessionConnected(state, now));

  return (
    <MenuIconButton
      onClick={onClick ?? (() => {})}
      stopColors={isSocketConnectedToWhatsApp ? greenStopColors : redStopColors}
      hoverStopColors={isSocketConnectedToWhatsApp ? greenStopColors : redStopColors}
      Icon={isSocketConnectedToWhatsApp ? <Sync /> : <SyncDisabled />}
      alt={isSocketConnectedToWhatsApp ? "Connected" : "Connect to send messages offline"}
    />
  );
};

SocketConnectionStatusButton.propTypes = {
  onClick: PropTypes.func
};

export default SocketConnectionStatusButton;
